module.exports = __webpack_public_path__ + "static/media/motorcycle.021cde61.svg";